import { jsx } from 'react/jsx-runtime';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './button.js';
import '@radix-ui/react-progress';
import '../../contexts/AppContext.js';
import 'lucide-react';
import 'react';
import '../../lib/toast.js';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'react-day-picker';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import './radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Display component for rendering rich text HTML content
 * Applies TipTap styling to the rendered HTML
 */
function RichTextContent({ content, children, className, ...props }) {
    return (jsx("div", { className: cn('tiptap', className), ...props, children: jsx("div", { dangerouslySetInnerHTML: { __html: content || children || '' } }) }));
}

export { RichTextContent };
//# sourceMappingURL=RichTextContent.js.map
